export function currencyFormat(
    price: number,
    currency: "id" | "my" | "en",
): string {
    return new Intl.NumberFormat(
        currency === "id" ? "id-ID" : currency === "my" ? "ms-MY" : "en-US",
        {
            style: "currency",
            currency:
                currency === "id" ? "IDR" : currency === "my" ? "MYR" : "USD",
            maximumFractionDigits: currency === "id" ? 0 : 2,
        },
    ).format(price);
}
